import React from "react"
import Calculator from "./Calculator"
import styled from "styled-components"
import { fontGray, mainLightGray } from "../../styles"

const SavingsSection = () => {
  return (
    <Wrapper className="py-5" id="savings-section">
      <div className="container-xl">
        <div className="row justify-content-center text-center">
          <div className="col-lg-12">
            <h2>Visualize Your Potential Savings</h2>
          </div>
        </div>
        <div className="row justify-content-center mt-4">
          <div className="col-lg-12 text-center">
            <Calculator />
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  padding: 4rem 0;
  h2 {
    font-size: 38pt;
    margin: 2rem 0 5rem 0;
  }
  .donut-text {
    font-size: 12px;
    font-weight: 400;
    text-transform: uppercase;
  }
  .graph-info {
    color: ${fontGray};
  }
  span.text-green {
    color: #3dc578;
  }
  span.text-tang {
    color: #fb592f;
  }
  .savings-input {
    padding: 0.8rem 1.5rem 1rem 1.5rem;
    border: $outline-gray 2px solid;
  }
  ::placeholder {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    color: black;
    text-align: center;
  }

  @keyframes donut-fill {
    to {
      stroke-dasharray: 0 100;
    }
  }

  .donut {
    width: 12.5rem;
    height: 12.5rem;
    position: relative;
    margin: auto;
  }

  .donut__frame,
  .donut__circle {
    stroke-width: 0.125rem;
    fill: none;
  }

  .donut__frame {
    stroke: ${mainLightGray};
  }

  .donut__circle {
    stroke: ${mainLightGray};
    stroke-linecap: round;
  }

  .donut__canvas {
    width: 100%;
    height: 100%;
    display: block;
    position: relative;
    z-index: 2;
  }

  .donut__circle {
    transform: rotate(90deg);
    transform-origin: 50% 50%;
    animation: donut-fill 2s;
  }

  .donut__circle[stroke-dasharray="0 100"] {
    stroke: none;
  }

  .donut.is--negative .donut__circle {
    transform: rotate(90deg) scaleY(-1);
  }

  .donut-complex text {
    display: none;
  }

  .donut-complex circle {
    border: ${mainLightGray} 2px solid;
    fill: none;
    transition: stroke-dashoffset 1s ease-in-out;
  }

  .donut-complex:not(.donut-complex--loaded) circle {
    stroke-dashoffset: 0;
  }
`

export default SavingsSection
